import axios from 'axios';

const API_BASE_URL = '/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const authService = {
  register: (userData) => apiClient.post('/auth/register', userData),
  login: (credentials) => apiClient.post('/auth/login', credentials),
  getMe: () => apiClient.get('/users/profile'),
};

export const clubService = {
  getAllClubs: (params) => apiClient.get('/clubs', { params }),
  getClubById: (id) => apiClient.get(`/clubs/${id}`),
  createClub: (data) => apiClient.post('/clubs', data),
  updateClub: (id, data) => apiClient.put(`/clubs/${id}`, data),
  deleteClub: (id) => apiClient.delete(`/clubs/${id}`),
  getClubStats: (id) => apiClient.get(`/clubs/${id}/stats`),
};

export const eventService = {
  getAllEvents: () => apiClient.get('/events'),
  getEventById: (id) => apiClient.get(`/events/${id}`),
  getEventsByClub: (clubId) => apiClient.get(`/events/club/${clubId}`),
  createEvent: (data) => apiClient.post('/events', data),
  registerForEvent: (eventId) => apiClient.post(`/events/${eventId}/register`),
  updateEvent: (id, data) => apiClient.put(`/events/${id}`, data),
  deleteEvent: (id) => apiClient.delete(`/events/${id}`),
};

export const membershipService = {
  applyForMembership: (data) => apiClient.post('/memberships/apply', data),
  getMembershipStatus: () => apiClient.get('/memberships/status'),
  getUserMemberships: () => apiClient.get('/memberships/my-memberships'),
  getPendingMemberships: () => apiClient.get('/memberships/pending'),
  approveMembership: (id) => apiClient.put(`/memberships/${id}/approve`),
  rejectMembership: (id, data) => apiClient.put(`/memberships/${id}/reject`, data),
};

export const forumService = {
  getAllPosts: () => apiClient.get('/forum'),
  getPostsByClub: (clubId) => apiClient.get(`/forum/club/${clubId}`),
  getPostById: (id) => apiClient.get(`/forum/${id}`),
  createPost: (data) => apiClient.post('/forum', data),
  replyToPost: (id, data) => apiClient.post(`/forum/${id}/reply`, data),
  upvotePost: (id) => apiClient.put(`/forum/${id}/upvote`),
  markAsResolved: (id) => apiClient.put(`/forum/${id}/resolve`),
};

export const notificationService = {
  getNotifications: () => apiClient.get('/notifications'),
  markAsRead: (id) => apiClient.put(`/notifications/${id}/read`),
  markAllAsRead: () => apiClient.put('/notifications/read-all'),
  deleteNotification: (id) => apiClient.delete(`/notifications/${id}`),
};

export const adminService = {
  getAnalytics: () => apiClient.get('/admin/analytics'),
  getAllUsers: () => apiClient.get('/admin/users'),
  updateUserRole: (data) => apiClient.put('/admin/update-role', data),
  assignClubAdmin: (data) => apiClient.put('/admin/assign-club-admin', data),
};

export const userService = {
  getUserProfile: () => apiClient.get('/users/profile'),
  updateProfile: (data) => apiClient.put('/users/profile', data),
  getAllUsers: () => apiClient.get('/users/all'),
};

export default apiClient;
